module.exports = __webpack_public_path__ + "img/hr-train-wheels-2.b6971295.png";